import {
  CalculadoraFrete,
  FiltrosPrecificacao,
  HistoricoVariacaoFrete,
  LotesConcorrentes,
  MapaPrecificacao,
} from '@sotran/lib-shipper';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import SubHeader from '../../components/SubHeader';
import { useAuth } from '../../security/authContext';
import apiAts from '../../services/apiATS';
import apiDatalake from '../../services/apiDatalake';
import apiNetCore from '../../services/apiNetCore';
import apiShipper from '../../services/apiShipper';
import { Tabs } from '../../styles/global';
import { Card } from './styles';

const { TabPane } = Tabs;

export default function Precificacao() {
  const params = useParams();

  const cidadeDTO = {
    cidadeNome: '',
    idCidade: 0,
    idEstado: 0,
    uf: '',
    ibge: 0,
    latitude: 0,
    longitude: 0,
    sigla: '',
  };

  const { user } = useAuth();

  const [currentTab, setCurrentTab] = useState(1);

  /**
   ** @param { Filtros } data
   */
  const [filtros, setFiltros] = useState({
    cidadeOrigem: cidadeDTO,
    cidadeDestino: cidadeDTO,
    produtos: [
      {
        id: 0,
        nome: '',
      },
    ],
  });

  const [filtroLoteConcorrente, setFiltroLoteConcorrente] = useState({
    idCidadeOrigem: 0,
    idCidadeDestino: 0,
    idProduto: 0,
  });

  const [filtroHistoricoVariacao, setFiltroHistoricoVariacao] = useState({
    ibgeCidadeOrigem: 0,
    ibgeCidadeDestino: 0,
    produtos: [],
  });

  const [filtroMapaPrecificacao, setFiltroMapaPrecificacao] = useState({
    Cidade: null,
    SiglaUf: '',
    latitude: null,
    longitude: null,
  });

  const tabs = [
    {
      key: '1',
      title: 'Precificação',
      content: (
        <>
          <CalculadoraFrete
            apiNetCore={apiNetCore}
            apiShipper={apiShipper}
            isUsuarioSotran={user.profile === 'SOTRAN'}
            clienteId={user.cliente_id}
            filtrosPrecificacao={filtroLoteConcorrente}
          />
          <HistoricoVariacaoFrete
            apiAts={apiAts}
            apiDatalake={apiDatalake}
            filtrosPrecificacao={filtroHistoricoVariacao}
            isUsuarioSotran={user.profile === 'SOTRAN'}
          />
        </>
      ),
    },
    {
      key: '2',
      title: 'Lotes concorrentes',
      content: (
        <LotesConcorrentes
          apiNetCore={apiNetCore}
          filtrosPrecificacao={filtroLoteConcorrente}
          isUsuarioSotran={user.profile === 'SOTRAN'}
        />
      ),
    },
    {
      key: '3',
      title: 'Mapa de motoristas',
      content: (
        <MapaPrecificacao
          apiAts={apiAts}
          apiNetCore={apiNetCore}
          filtrosPrecificacao={filtroMapaPrecificacao}
          isUsuarioSotran={user.profile === 'SOTRAN'}
          mapHeight="60vh"
        />
      ),
    },
  ];

  const breadcrumbs = [
    {
      breadcrumbName: tabs[currentTab - 1].title,
    },
  ];

  const onTabClickChange = value => setCurrentTab(Number(value));

  useEffect(() => {
    if (filtros) {
      const { cidadeOrigem, cidadeDestino, produtos } = filtros;

      setFiltroHistoricoVariacao({
        ibgeCidadeOrigem: cidadeOrigem && cidadeOrigem.ibge,
        ibgeCidadeDestino: cidadeDestino && cidadeDestino.ibge,
        produtos: produtos?.length
          ? produtos.filter(prod => prod.nome !== '').map(prod => prod.nome)
          : undefined,
      });

      setFiltroLoteConcorrente({
        idCidadeOrigem: cidadeOrigem && cidadeOrigem.idCidade,
        idCidadeDestino: cidadeDestino && cidadeDestino.idCidade,
        idProduto: produtos && produtos[0].id,
      });

      setFiltroMapaPrecificacao({
        Cidade: cidadeOrigem && cidadeOrigem.idCidade,
        SiglaUf: cidadeOrigem && cidadeOrigem.sigla,
        latitude: cidadeOrigem && cidadeOrigem.latitude,
        longitude: cidadeOrigem && cidadeOrigem.longitude,
      });
    }
  }, [filtros]);

  return (
    <>
      <SubHeader breadcrumbs={breadcrumbs} />
      <Card className="pl-24 pr-24 pt-20">
        <FiltrosPrecificacao
          params={params}
          apiDatalake={apiDatalake}
          apiNetCore={apiNetCore}
          setFiltros={setFiltros}
        />
      </Card>
      <Card bordered={false} className="pt-0 height-85">
        <Tabs activeKey={currentTab.toString()} onTabClick={onTabClickChange}>
          {tabs.map(item => (
            <TabPane tab={item.title} key={item.key}>
              {item.content}
            </TabPane>
          ))}
        </Tabs>
      </Card>
    </>
  );
}
